<ng-container *ngIf="rootNodeId$ | async as rootNodeId">
  <sd-mobile-categories-menu
    *ngIf="deviceService.isTabletMdDown$ | async; else desktopCategoriesMenu"
    [rootNodeId]="rootNodeId"
  ></sd-mobile-categories-menu>

  <ng-template #desktopCategoriesMenu>
    <sd-desktop-categories-menu [rootNodeId]="rootNodeId"></sd-desktop-categories-menu>
  </ng-template>
</ng-container>
